import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import AddIcon from '../../../assets/images/icon-add.svg';

const BASE_BUTTON_CLASSES = ['rds-Button'];

const BASE_BUTTON_SIZES = {
  small: 'rds-Button--small',
  medium: '',
  large: 'rds-Button--large',
  extraLarge: 'rds-Button--xlarge'
};

const BASE_BUTTON_STYLES = {
  default: '',
  secondary: 'rds-Button--ghost',
  tertiary: 'rds-Button--ghost border-transparent'
};

function getSize(size) {
  if (BASE_BUTTON_SIZES.hasOwnProperty(size)) {
    return BASE_BUTTON_SIZES[size].split(' ');
  }
  return [];
}

function getStyle(style) {
  if (BASE_BUTTON_STYLES.hasOwnProperty(style)) {
    return BASE_BUTTON_STYLES[style].split(' ');
  }
  return [];
}

function unique(arr) {
  return Object.keys(
    arr.reduce(
      (acc, curr) => ({
        ...acc,
        [curr]: true
      }),
      {}
    )
  );
}

function getClassNames(classes) {
  const uniqueClasses = unique(classes);
  return uniqueClasses.join(' ');
}

export const Button = ({
  size = 'medium',
  tag = 'a',
  style = 'default',
  ...props
}) => {
  const classes = getClassNames([
    ...BASE_BUTTON_CLASSES,
    ...getSize(size),
    ...getStyle(style),
    props.className
  ]);
  const Tag = `${tag}`;

  return (
    <Tag {...props} className={classes}>
      {props.children}
    </Tag>
  );
};

Button.propTypes = {
  size: PropTypes.oneOf(Object.keys(BASE_BUTTON_SIZES)),
  style: PropTypes.oneOf(Object.keys(BASE_BUTTON_STYLES)),
  tag: PropTypes.oneOf(['a', 'button']),
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export const AddButton = ({ isSubmitting, className, ...props }) => (
  <Button
    {...props}
    size="large"
    className={classNames(className, 'rds-Button', 'ActionStepCard-button', {
      'is-disabled': isSubmitting
    })}
    tag="button"
  >
    <AddIcon className="gzl-Icon rds-Button-icon rds-Button-icon--left" />
    Add
  </Button>
);

AddButton.propTypes = {
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
  selectTask: PropTypes.func
};
